<template>
    <div ref="modal" class="modal fade add-product-modal-popup" tabindex="-1" role="dialog" :id="id">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true">×</span>
                    </button>
                    <h4 class="modal-title p-0-30" id="modal-title">Add New Tax Rate</h4>
                    <div class="modal-body modal-body-assign">

                      <div class="form-group">
                          <label class="contorl-label col-sm-2">Name: </label>
                          <div class="col-sm-10">
                              <input type="text" v-model="tax_rate_name"  class="form-control">
                              <span class="text text-danger error-label" v-if="tax_rate_name_validation_message">{{tax_rate_name_validation_message}}</span>
                          </div>

                      </div>
                      <div class="form-group">
                          <label class="contorl-label col-sm-2">Value: </label>
                          <div class="col-sm-10">
                              <span id="percent-sign">%</span>
                              <input type="text" v-model="tax_rate_value"  class="form-control percentage_only">
                              <span class="text text-danger error-label" v-if="tax_rate_value_validation_message">{{tax_rate_value_validation_message}}</span>
                          </div>

                      </div>
                      <div class="modal-footer" style="padding-left: 0;padding-right: 0">
                            <button  @click="submitTaxForm" type="button" class="btn btn-primary new-design pull-right">
                              Add
                            </button>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-primary new-design pull-left">
                              Cancel
                            </button>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import {storeNewTaxRate} from "@/modules/Services/api/billing";

export default {
    name: "TaxRatePopup",
    props: {
        id: {
            required: true
        },
        productId: {
            default() {
                return null
            }
        },
        componentCounter: {
            default() {
                return null
            }
        },
    },
    data() {
        return {
            tax_rate_name: '',
            tax_rate_value: '',
            tax_rate_name_validation_message:'',
            tax_rate_value_validation_message:''
          }
        },

    methods:{
        async submitTaxForm() {
            this.tax_rate_value_validation_message = this.tax_rate_name_validation_message = "";
            if(!this.tax_rate_value.match(/^-?\d*(\.\d+)?$/) || this.tax_rate_value >= 100 || this.tax_rate_value == ''){
                this.tax_rate_value_validation_message = "This field must be less than or equal 100 and greater than or equal 0";
                return;
            }
            else if (this.tax_rate_name == ""){
                this.tax_rate_name_validation_message = "This field is required";
                return;
            }
            else {
            event.stopPropagation()
            let response = await storeNewTaxRate(this.tax_rate_name,this.tax_rate_value);
                response.data.productId = this.productId
                response.data.componentCounter = this.componentCounter;
            EventBus.$emit('newTaxRateOptionAdded',response.data)
            $(this.$refs['modal']).modal('toggle')
            }
        },
    },
}
</script>

<style scoped>

.contorl-label{
    padding-top: 7px;
}
#percent-sign {
    top: 8px;
    right: 25px;
    position: absolute;
    z-index: 1;
    font-size: medium;
}
.modal-header.new-design {
  border-bottom: unset;
}

.has-error .form-control {
  border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #2E4051;
  display: inline;
}

.modal-footer.new-design {
  border-top: unset;
}

.close-icon {
  float: right;
}

.clickable {
  cursor: pointer;
}

.error-label {
  top: 8px;
  position: relative;
}

.btn.new-design {
  border-radius: 8px;
  padding: 12px 16px;
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #FFFFFF;
}

.btn-primary.new-design {
  background: #2E4051 !important;
}

.form-control.new-design::placeholder {
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.form-control.new-design {
  padding: 16px;
  border: 1px solid #E0E2E5;
  border-radius: 8px;
  box-sizing: border-box;

  //height: 56px;

  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.btn.new-design {
  margin-bottom: unset;
}

.modal-body-assign{
  height: auto !important;
}
</style>